import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Plus, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTran } from "@/hooks";
import { customDisclosureStore } from "../stores/custom-disclosure.store";
import CustomDisclosureDialog from "../components/customDisclosures/CustomDisclosureDialog";
import AnalyticsCards from "../components/customDisclosures/AnalyticsCards";
import DisclosureFilters from "../components/customDisclosures/DisclosureFilters";
import DisclosureTable from "../components/customDisclosures/DisclosureTable";
import DisclosurePagination from "../components/customDisclosures/DisclosurePagination";
import { PageHeader } from "@/components/common";

const CustomDisclosureLibraryPage = observer(() => {
  const { t } = useTran();
  const [showDialog, setShowDialog] = useState(false);
  const [editingDisclosure, setEditingDisclosure] = useState(null);

  useEffect(() => {
    customDisclosureStore.loadDisclosures();
    customDisclosureStore.loadAnalytics();
  }, []);

  const handleCreate = () => {
    setEditingDisclosure(null);
    setShowDialog(true);
  };

  const handleEdit = (disclosure) => {
    setEditingDisclosure(disclosure);
    setShowDialog(true);
  };

  return (
    <div className="flex-1 flex flex-col min-h-0 gap-y-6">
      {/* Header */}
      <PageHeader
        title={t("Custom Disclosure Library")}
        icon={BookOpen}
        description={t(
          "Manage company-wide custom ESG metrics and disclosures",
        )}
        actions={
          <Button onClick={handleCreate} className="gap-2">
            <Plus className="h-4 w-4" />
            {t("Create Custom Disclosure")}
          </Button>
        }
      />

      {/* Analytics Cards */}
      <AnalyticsCards />

      {/* Filters & Actions */}
      <DisclosureFilters />

      {/* Table */}
      <DisclosureTable onCreate={handleCreate} onEdit={handleEdit} />

      {/* Pagination */}
      <DisclosurePagination />

      {/* Dialog */}
      <CustomDisclosureDialog
        open={showDialog}
        onOpenChange={setShowDialog}
        editingDisclosure={editingDisclosure}
      />
    </div>
  );
});

export default CustomDisclosureLibraryPage;
